//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_passEnvironment = 0.0;\n\
";
